import type { ArcanaReadingQueueItemDto, ArcanaReadingResponseDto } from '@lunary/api-client'
import { ArchCard } from '@lunary/ui-web/arch-card'
import { READING_STATUS, listTimeLabel, previewText } from '@lunary/app-core/reading-chat-model'
import expert from '../../shared/ui/expert.module.css'
import { formatDateTime } from '../users/labels'
import { PersonCard } from './person-card'
import styles from './readings.module.css'

type Props = {
  reading: ArcanaReadingQueueItemDto
  history: ArcanaReadingResponseDto[]
}

const DONE = new Set(['ready', 'clarifying', 'closed'])

export function ContextPane({ reading, history }: Props) {
  const arcana = reading.personal_arcana
  const trait = arcana?.arcana_trait
  const all = [reading, ...history]
  return (
    <aside className={styles.side} aria-label="Контекст человека">
      {reading.person && <PersonCard person={reading.person} readings={all.length} done={all.filter((r) => DONE.has(r.status)).length} />}
      <div className={styles.context}>
        <span className={expert.historyDate}>Личный аркан и знак</span>
        {arcana ? (
          <div className={styles.contextRow}>
            <ArchCard number={arcana.arcana_id} name={arcana.arcana.name} size="sm" />
            <div className={styles.contextText}>
              <span className={expert.cardName}>{arcana.arcana.name}</span>
              <span className="muted">{arcana.zodiac_name}</span>
            </div>
          </div>
        ) : (
          <p className="muted">Человек не указал дату рождения.</p>
        )}
        {trait && (
          <dl className={styles.traits}>
            <dt>Опора</dt>
            <dd>{trait.support}</dd>
            <dt>На что смотреть</dt>
            <dd>{trait.attention}</dd>
            <dt>Вопрос себе</dt>
            <dd>{trait.question}</dd>
          </dl>
        )}
        <span className={styles.meta}>Запрос от {formatDateTime(reading.requested_at)}</span>
      </div>
      <div className={styles.context}>
        <span className={expert.historyDate}>Другие разборы человека</span>
        {history.length === 0 && <p className="muted">Это первый разбор.</p>}
        <ul className={styles.history}>
          {history.map((h) => (
            <li key={h.id}>
              <span className={styles.queueTop}>
                <span className={styles.topic}>{h.topic_title}</span>
                <span className={styles.meta}>
                  {READING_STATUS[h.status]?.label ?? h.status} · {listTimeLabel(h.last_message_at)}
                </span>
              </span>
              <span className={styles.historyText}>{h.question || previewText(h, 'expert')}</span>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  )
}
